import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { PageHero, CTABand } from "@/components/site/PageHero";
import { Container, Overline, Reveal } from "@/lib/ui";
import { SERVICE_PILLARS, ALL_SERVICES, IMAGES } from "@/data/site";
import { SERVICE } from "@/constants/testIds";

export default function Services() {
  return (
    <>
      <PageHero
        id="services"
        overline="Services"
        title="One accountable platform, from underwriting to disposition."
        lead="GreatLeaf delivers property management, asset management, hospitality operations and transaction support as a single integrated service — never a hand-off between vendors."
        image={IMAGES.commercial}
      />

      <section className="py-24 md:py-32 bg-[#F7F7F5]">
        <Container>
          <div className="grid md:grid-cols-2 gap-5">
            {SERVICE_PILLARS.map((p, i) => (
              <Reveal key={p.slug} delay={(i % 2) * 0.08}>
                <Link to={`/${p.slug}`} data-testid={SERVICE.link(p.slug)}
                  className="group block bg-white border border-[#E5E5DF] rounded-sm p-8 h-full hover:border-[#1B3B2B] transition-colors duration-300">
                  <div className="flex items-start justify-between">
                    <h2 className="font-display text-2xl text-[#121A16]">{p.title}</h2>
                    <ArrowUpRight className="w-5 h-5 text-[#275C43] opacity-0 group-hover:opacity-100 transition-opacity" />
                  </div>
                  <p className="mt-3 text-[#5C6660] leading-relaxed">{p.lead}</p>
                  <ul className="mt-6 grid grid-cols-1 gap-2">
                    {p.items.map((it) => (
                      <li key={it} className="flex items-center gap-2.5 text-sm text-[#121A16]">
                        <Check className="w-4 h-4 text-[#275C43]" /> {it}
                      </li>
                    ))}
                  </ul>
                </Link>
              </Reveal>
            ))}
          </div>
        </Container>
      </section>

      <section className="py-24 md:py-32 bg-white border-t border-[#E5E5DF]">
        <Container>
          <Overline>Full Capabilities</Overline>
          <h2 className="mt-6 font-display font-light text-3xl md:text-4xl leading-tight text-[#121A16] max-w-2xl">
            Every discipline required to operate institutional real estate.
          </h2>
          <div className="mt-10 flex flex-wrap gap-2.5">
            {ALL_SERVICES.map((s) => (
              <span key={s} className="text-sm font-data text-[#1B3B2B] bg-[#F0F4F1] border border-[#DCE6DF] rounded-sm px-3.5 py-2">
                {s}
              </span>
            ))}
          </div>
        </Container>
      </section>

      <CTABand />
    </>
  );
}
